/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SensorDataRequestCreateResponse
 */
export interface SensorDataRequestCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof SensorDataRequestCreateResponse
     */
    requestId: string;
}

/**
 * Check if a given object implements the SensorDataRequestCreateResponse interface.
 */
export function instanceOfSensorDataRequestCreateResponse(value: object): value is SensorDataRequestCreateResponse {
    if ((!('requestId' in (value as Record<string, any>)) && !('request_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['requestId'] === undefined && (value as Record<string, any>)['request_id'] === undefined)) return false;
    return true;
}

export function SensorDataRequestCreateResponseFromJSON(json: any): SensorDataRequestCreateResponse {
    return SensorDataRequestCreateResponseFromJSONTyped(json, false);
}

export function SensorDataRequestCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensorDataRequestCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['request_id'],
    };
}

export function SensorDataRequestCreateResponseToJSON(json: any): SensorDataRequestCreateResponse {
    return SensorDataRequestCreateResponseToJSONTyped(json, false);
}

export function SensorDataRequestCreateResponseToJSONTyped(value?: SensorDataRequestCreateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'request_id': value['requestId'],
    };
}

